import {createSlice} from "@reduxjs/toolkit";

export const WarrantySlice = createSlice({
    name: "warrantySlice",
    initialState: {
        allWarrantiedProduct: []
    },
    reducers: {
        getAllWarrantiedProdReducer: (state, action) => {
            state.allWarrantiedProduct = action.payload
        }
    }
})